export const MuiListItemText = () => ({
    root: {
        marginTop: '0',
        marginBottom: '0',
    },
});
